import { z } from "zod";
import { emailSchema } from "./common";

// Login form schema
export const createLoginFormSchema = () => {
  return z.object({
    email: emailSchema,
    password: z
      .string()
      .min(1, "Password is required")
  });
};
